<template>
  <div class="login-page">
    <div class="login-card">
      <div class="login-left">
        <div class="login-logo"></div>
        <div class="login-title">欢迎登录Beepay产品管理系统</div>
      </div>
      <div class="login-right">
        <h2>登录</h2>
        <a-form
          class="login-form"
          @submit="handleSubmit" :form="form">
          <a-form-item>
            <a-input
              size="large"
              type="text"
              placeholder="请输入账号"
              v-decorator="[
                'userName',
                {
                  rules:[
                    { required: true, message: '请输入账号' }
                    // { validator: handleUsernameOrEmail }
                  ],
                  validateTrigger: 'change'}
              ]"
            >
              <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }" />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input
              size="large"
              type="password"
              autocomplete="false"
              placeholder="请输入密码"
              v-decorator="[
                'password',
                {rules: [{ required: true, message: '请输入密码' }], validateTrigger: 'blur'}
              ]"
            >
              <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-button
              class="login-btn"
              htmlType="submit"
              type="primary"
              :loading="loginBtn"
            >
              登录
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
import getVuexWithNameSpace from '../../utils/storeHelper'

const { mapActions } = getVuexWithNameSpace('user')
const { mapActions: mapActionsApp } = getVuexWithNameSpace('app')

export default {
  name: 'Login',
  data () {
    return {
      form: this.$form.createForm(this),
      loginBtn: false
    }
  },
  created () {
  },
  methods: {
    ...mapActions(['Login']),
    ...mapActionsApp(['loadSystemMaps']),
    handleUsernameOrEmail (rule, value, callback) {
      const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
      if (value && !regex.test(value)) {
        callback(new Error('账号格式不正确'))
      }
      callback()
    },
    handleSubmit (e) {
      e.preventDefault()
      // console.log('login handler')
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loginBtn = true
          this.Login(values)
            .then(async (res) => {
              // console.log(res)
              await this.loadSystemMaps()
              this.$router.push({
                path: '/'
              })
            })
            .catch(e => {
              // console.log(err)
            })
            .finally(() => {
              this.loginBtn = false
            })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.login-page {
  width: 100%;
  height: 100vh;
  position: relative;
  background: #f3f6f9;

  .login-card {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 852px;
    height: 523px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, .06);

    .login-left {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      width: 342px;
      height: 523px;
      background: url('~@/assets/login-bg.png') no-repeat 0 0;
      background-size: cover;

      .login-logo {
        width: 126px;
        height: 36px;
        margin: 24px 0 0 24px;
        background: url("~@/assets/beefinx-logo.png") no-repeat 0 0;
        background-size: cover;
      }

      .login-title {
        width: 246px;
        height: 64px;
        margin: 40px auto 0;
        font-family: PingFangSC;
        font-weight: 600;
        color: #fff;
        font-size: 24px;
        line-height: 32px;
      }
    }

    .login-right {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 510px;
      height: 523px;

      h2 {
        text-align: center;
        font-size: 24px;
        font-family: PingFangSC;
        font-weight: 500;
        color: #40484b;
      }

      .login-form {
        width: 310px;
        height: auto;
        margin: 40px auto 0;

        .login-btn {
          width: 100%;
          margin-top: 24px;
        }
      }
    }
  }
}
</style>
